import  { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ProtectedRoute({ children, allowedRoles }) {
    const navigate = useNavigate();
    const userData = localStorage.getItem('user');
    const userRole = userData ? JSON.parse(userData).role : 'Guest';

    useEffect(() => {
        // If the user is not authorized, show an alert and redirect to login
        if (!allowedRoles.includes(userRole)) {
            alert('You Are Not Authorized For This Page.');
            navigate('/login', { replace: true });
        }
    }, [allowedRoles, userRole, navigate]);

    // Render children if user is authorized
    if (allowedRoles.includes(userRole)) {
        return children;
    }

    // Render null or a loading spinner while navigating
    return null;
}

export default ProtectedRoute;
